/*
 *
 * Validate Form
 *
 * */
const validate = (values) => {
  const errors = {};

  if (!values.hasFurniture) {
    errors.hasFurniture = `We need to know if you're donating any large furniture or items that require a larger truck.`;
  }

  if (!values.zipCode) {
    errors.zipCode = "We need your zip code to find available pickup dates.";
  }

  if (values.zipCode && values.zipCode.length < 5) {
    errors.zipCode = "Your zipcode should be 5 digits";
  }

  return errors;
};

export default validate;
